module.exports = __webpack_public_path__ + "img/2.836e3267.jpg";